import { StepPill, StepRail } from './styles';

type StepsType = {
  labels: string[];
  current: number;
};

export const Steps = ({ labels, current }: StepsType) => (
  <StepRail>
    {labels.map((label, index) => {
      const stepCount = index + 1;
      const state = stepCount < current ? 'done' : stepCount === current ? 'current' : 'todo';
      const isLast = index === labels.length - 1;

      return (
        <StepPill key={label} $state={state} $last={isLast}>
          <span>{state === 'done' ? '✓' : `${stepCount}.`}</span>
          {label}
        </StepPill>
      );
    })}
  </StepRail>
);
